import { z } from 'zod';
import { applyStartDateBeforeEndateOrderSchema } from './schemas/start-date-before-end-date-order.schema';
import { BuildFormSchema } from './build-form-schema.types';
import { FormRule, FormRuleType } from '../../dynamic-form.types';

const formSchemaAppliers: Record<FormRuleType, BuildFormSchema> = {
  start_date_before_end_date: applyStartDateBeforeEndateOrderSchema,
};

const applySingleSchema = (schema: z.ZodTypeAny, rule: FormRule) => {
  const applier = formSchemaAppliers[rule.type];
  if (!applier) {
    throw new Error(`Unsupported form rule type: ${rule.type}`);
  }

  return applier(schema, rule);
};

export function buildFormSchemas(
  schema: z.ZodObject<Record<string, z.ZodTypeAny>>,
  rules: FormRule[]
) {
  let currentSchema: z.ZodObject<any> | z.ZodEffects<z.ZodTypeAny> = schema;
  rules.forEach((rule) => {
    currentSchema = applySingleSchema(currentSchema, rule);
  });

  return currentSchema;
}
